<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      date_marty: "",
      place_marty: "",
      dept: "",
      attachment_info: "",
      attachment_qssam: "",
    };
  },
  validations: {
    date_marty: { required },
    place_marty: { required, minLength: minLength(2), maxLength: maxLength(50) },
    dept: { required, minLength: minLength(2), maxLength: maxLength(50) },
    attachment_info: {
      // required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },
    attachment_qssam: {
      required,
      fileType: fileType("application/pdf"),
      fileSize: fileSize(1024 * 1024 * 2),
    },

    form: ["date_marty", "place_marty", "dept", "attachment_info", "attachment_qssam"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات الاستشهاد</h5></div>
      <b-form-group
        class="col-md-4 mb-3"
        label="تاريخ الاستشهاد : "
        label-for="date_marty"
      >
        <date-picker
          id="date_marty"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ الاستشهاد"
          v-model="date_marty"
          :class="{ 'is-invalid': $v.date_marty.$error }"
        ></date-picker>
        <div v-if="$v.date_marty.$error" class="invalid-feedback">
          <span v-if="!$v.date_marty.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" محل الحادث : " label-for="place_marty">
        <b-form-input
          id="place_marty"
          type="text"
          placeholder="ادخل محل الحادث"
          v-model="place_marty"
          :class="{ 'is-invalid': $v.place_marty.$error }"
        ></b-form-input>
        <div v-if="$v.place_marty.$error" class="invalid-feedback">
          <span v-if="!$v.place_marty.required">هذا الحقل الزامي</span>
          <span v-if="!$v.place_marty.minLength"
            >يجب أن يتكون محل الحادث من حرفين على الأقل</span
          >
          <span v-if="!$v.place_marty.maxLength"
            >يجب أن يتكون محل الحادث من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" التشكيل : " label-for="dept">
        <b-form-input
          id="dept"
          type="text"
          placeholder="ادخل التشكيل"
          v-model="dept"
          :class="{ 'is-invalid': $v.dept.$error }"
        ></b-form-input>
        <div v-if="$v.dept.$error" class="invalid-feedback">
          <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
          <span v-if="!$v.dept.minLength">يجب أن يتكون التشكيل من حرفين على الأقل</span>
          <span v-if="!$v.dept.maxLength">يجب أن يتكون التشكيل من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <hr class="hr-title" />
    <div class="break-title">
      <h5 class="mb-4">مرفق تأييد الاستشهاد و القسام الشرعي</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <ul class="li-attachments">
          <li>اضافة مرفق القسام الشرعي</li>
          <li>
            يجب ارفاق مستند القسام الشرعي ورفعه بملف واحد بصيغة ( pdf. ) وبحجم لا يتجاوز (
            2mb ) .
          </li>
        </ul>
        <b-form-group class="" label=" مرفق القسام الشرعي :" label-for="attachment_qssam">
          <div class="custom_file">
            <b-form-file
              id="attachment_qssam"
              class=""
              placeholder="اختر المرفق"
              accept=".pdf"
              v-model="attachment_qssam"
              :class="{ 'is-invalid': $v.attachment_qssam.$error }"
            ></b-form-file>
            <div v-if="$v.attachment_qssam.$error" class="invalid-feedback">
              <span v-if="!$v.attachment_qssam.required">هذا الحقل الزامي </span>
              <span v-if="!$v.attachment_qssam.fileSize"
                >يجب ان لا يتجاوز حجم الملف 2mb
              </span>
              <span v-if="!$v.attachment_qssam.fileType">يجب ان يكون نوع الملف pdf </span>
            </div>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6 mb-3">
        <ul class="li-attachments">
          <li>مرفق تأييد الاستشهاد و شهادة الوفاة .</li>
          <li>
            يجب جمع مرفق تأييد الاستشهاد وشهادة الوفاة ورفعها بملف واحد بصيغة ( pdf. )
            وبحجم لا يتجاوز ( 2mb ) .
          </li>
        </ul>
        <b-form-group
          class=""
          label=" مرفق تأييد الاستشهاد :"
          label-for="attachment_info"
        >
          <div class="custom_file">
            <b-form-file
              id="attachment_info"
              class=""
              placeholder="اختر المرفق"
              accept=".pdf"
              v-model="attachment_info"
              :class="{ 'is-invalid': $v.attachment_info.$error }"
            ></b-form-file>
            <div v-if="$v.attachment_info.$error" class="invalid-feedback">
              <!-- <span v-if="!$v.attachment_info.required">هذا الحقل الزامي </span> -->
              <span v-if="!$v.attachment_info.fileSize"
                >يجب ان لا يتجاوز حجم الملف 2mb
              </span>
              <span v-if="!$v.attachment_info.fileType">يجب ان يكون نوع الملف pdf </span>
            </div>
          </div>
        </b-form-group>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
